import { render, staticRenderFns } from "./VcDbUpload.vue?vue&type=template&id=2b7f4a3c&scoped=true"
import script from "./VcDbUpload.js?vue&type=script&lang=js&external"
export * from "./VcDbUpload.js?vue&type=script&lang=js&external"
import style0 from "./VcDbUpload.scss?vue&type=style&index=0&id=2b7f4a3c&prod&lang=scss&scoped=true&external"
import style1 from "./VcDbUpload.vue?vue&type=style&index=1&id=2b7f4a3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f4a3c",
  null
  
)

export default component.exports